// extracted by mini-css-extract-plugin
export default {"container":"UnauthorizedPage_container__81Fxm","content":"UnauthorizedPage_content__YFLDG","message":"UnauthorizedPage_message__dhVFE"};